import React from "react";
import ApiKeyForm from "./ApiKeyForm";
import { Paper, withStyles, Grid } from "@material-ui/core";
import { BackButton, hasPermission } from '../../../sc-utilities';
import { connect } from "react-redux";
import * as Yup from "yup";
import * as actions from '../store/securazeApiActions';
import History from "../../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    }
});

const ApiKeyCreate = props => {
    const { classes, activeCustomerID, translations, permissions, onCreateApiKey } = props;

    const handleSubmit = async data => {
        let result = await onCreateApiKey({ ...data, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    let initialValues = {
        ApiKey: "",
    };

    let formSettings = {
        Validation: {
            ApiKey: Yup.string().required("Required"),
        },
        FormTitle: translations["create_api_key"] || "Create API key",
        ButtonSubmit: hasPermission(permissions, "api_key_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };

    return (
        <Paper className={classes.root}>
            <Grid container spacing={10}>
                <Grid item xs={12}>
                    {BackButton(translations)}
                    <ApiKeyForm
                        classes={classes}
                        formSettings={formSettings}
                        initialValues={initialValues}
                        handleSubmit={handleSubmit}
                        translations={translations}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        permissions: state?.core?.login?.permissions || [],
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateApiKey: apiKey => dispatch(actions.createApiKey(apiKey))
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(ApiKeyCreate));